import { isAxiosError, type AxiosInstance } from "axios";
import type { Usuario } from "../usuario";
import { current_user } from ".";
import { access_token } from "./access-token";

type LoginRequest = {
    login: string,
    senha: string
}

type LoginResponse = {    
    usuario: Usuario,
    access_token: string
}

export class AuthService {
    constructor(private api: AxiosInstance) { }

    async login(request: LoginRequest): Promise<LoginResponse> {
        try {
            const { data } = await this.api.post<LoginResponse>(`/auth/signin`, request)
            
            current_user.value = data.usuario
            access_token.value = data.access_token
            
            return data
        } catch (error) {
            let title = 'Não foi possível efetuar o login'
            if (isAxiosError(error)) {
                title = error.response?.data.error
            } else if (error instanceof Error) {
                throw error
            }
            throw new Error(title)
        }
    }

    async logout() { 
        current_user.value = null
        access_token.value = null
    }
    async me(): Promise<Usuario> {
        const { data } = await this.api.get<Usuario>(`/auth/me`)
        return data
    }
}